import React from 'react'
import {FieldGoalListEditableProps} from "../../../../render/goal-list/goal-list-editable"
import {FieldPickerType} from "../../../../render/picker"
import HintPopover from "../../../../../gd-ui/hint-popover/hint-popover"

const debug = false
// const debug = "FieldDate_GoalListEditable"

export default class FieldDate_GoalListEditable extends React.Component<FieldGoalListEditableProps, any> {

    public previousValue        : any

    constructor(props:FieldGoalListEditableProps) {
        super(props);

        const value = _.get(props.model, props.field.fieldId, null)

        debug && console.log(debug, 'constructor', value)

        this.state = {
            initialPropsValue   : value, // required to check if currentOptions update needed on props changed
            currentValue        : value,
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId] // new value

        if (!_.isEqual(value, state.initialPropsValue)) {
            return {
                initialPropsValue   : value,
                currentValue        : value
            }
        }

        return null // no changes
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    // for compatibility with dropdown PopoverMenu (BaseDropdownPopoverMenu)
    onOptionClick = (option:any) => {this.onValueChange(option ? option.value : option)}

    onValueChange = (value:any) => {
        debug && console.log(debug, 'onValueChange', value)

        this.previousValue = this.state.currentValue;
        const newValue = value; //_.get(option, 'value', null);

        this.setState({
            currentValue: newValue
        }, () => {
            if (this.props.onChange) this.props.onChange(newValue, this.onCancelChange);
            this.hidePopover()
        })
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        })
    }

    render() {
        const {field} = this.props

        const classes = Classes("ui5-txt-less-important-small", this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        const showHint = _.get(this.props.configOptions, 'showHint', true)

        // need check value because of none
        if (this.state.currentValue) {
            return (
                <field.components.PickerValueNotEmpty {...this.props}
                                                      className     = {classes}
                                                      type          = {FieldPickerType.CIRCLE}
                                                      field         = {this.props.field}
                                                      value         = {this.state.currentValue}
                                                      onClick       = {this.showPopover}
                                                      onChange      = {this.onValueChange}
                                                      configOptions = {this.props.configOptions}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} value={this.state.currentValue} />}
                    {!this.state.showPopover && showHint && <HintPopover hint={this.props.field.label}/>}
                </field.components.PickerValueNotEmpty>
            )
        } else {
            return (
                <field.components.PickerValueEmpty {...this.props}
                                                   className        = {classes}
                                                   type             = {FieldPickerType.CIRCLE}
                                                   field            = {this.props.field}
                                                   onClick          = {this.showPopover}
                                                   configOptions    = {this.props.configOptions}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                    {!this.state.showPopover && showHint && <HintPopover hint={this.props.field.label}/>}
                </field.components.PickerValueEmpty>
            )
        }
    }
}
